import { ref } from "vue";
import { useRouter } from "vue-router";
import { useQuotaStore } from "@/stores/modules/quota/quota";
import { setWarningToast } from "@/helpers/notifications/toast";
import { translate } from "@/i18n/vueI18n";
import { hasSupportForNativeShorts } from "@/helpers/flutter/capabilities";
import {
  requestNativeShortCamera,
  type RequestNativeShortOptions,
} from "@/helpers/flutter/features/shorts-bridge";

const downloadAppModalOpen = ref(false);

export function useShortManagement() {
  const router = useRouter();
  const quotaStore = useQuotaStore();

  function triggerRecordShort(options?: RequestNativeShortOptions | Event) {
    if (quotaStore.isShortQuotaExceeded) {
      setWarningToast({
        message: translate("pages.setting.quota.short_limit_reached"),
      });
      router.push({
        name: "settings",
        query: { showQuota: "true", type: "shorts" },
      });
      return;
    }
    const shortOptions =
      options && "maxDurationSeconds" in options ? options : undefined;
    if (hasSupportForNativeShorts()) {
      requestNativeShortCamera(shortOptions);
    } else {
      downloadAppModalOpen.value = true;
    }
  }

  function closeDownloadAppModal() {
    downloadAppModalOpen.value = false;
  }

  return {
    downloadAppModalOpen,
    triggerRecordShort,
    closeDownloadAppModal,
  };
}
